import axios from '../../../../api/config'
import i18n from '../../../../i18n'
import {
  getVocabularyLearnNewOrReviewHistoryAPI,
  getVocabularyExamHistoryAPI,
  getAllCertsAPI
} from '../../../../api/vocabularyAPI'
import { secondToHMS } from '../../../../util/time'
import { roundDecimal } from '../../../../util/math'

const state = {
  waitForLearnNewHistory: false,
  waitForReviewHistory: false,
  waitForForceReviewHistory: false,
  waitForExamSimulationHistory: false,
  waitForExamHistory: false,
  waitForCertList: false,
  learnNewHistory: [],
  reviewHistory: [],
  forceReviewHistory: [],
  examSimulationHistory: [],
  examHistory: [],
  certList: []
}

const getters = {
}

const mutations = {
  setWait (state, payload) {
    const status = payload.flag
    switch (payload.mode) {
      case 'LEARNNEW':
        state.waitForLearnNewHistory = status
        break
      case 'REVIEW':
        state.waitForReviewHistory = status
        break
      case 'FORCEREVIEW':
        state.waitForForceReviewHistory = status
        break
      case 'EXAMSIMULATION':
        state.waitForExamSimulationHistory = status
        break
      case 'EXAM':
        state.waitForExamHistory = status
        break
      case 'CERT':
        state.waitForCertList = status
    }
  },
  setLearnNewOrReviewHistory (state, payload) {
    payload.data.map((each) => {
      each['usedTime'] = secondToHMS(each['usedTime'])
      each.detail.map((eachRecord) => {
        eachRecord.used_time = secondToHMS(eachRecord.used_time)
        eachRecord.correct_rate = roundDecimal(eachRecord.correct_rate * 100, 2) + '%'
      })
    })
    if (payload.mode === 'LEARNNEW') {
      state.learnNewHistory = payload.data
    } else if (payload.mode === 'REVIEW') {
      state.reviewHistory = payload.data
    } else if (payload.mode === 'FORCEREVIEW') {
      state.forceReviewHistory = payload.data
    }
  },
  setExamHistory (state, payload) {
    payload.data.map((each) => {
      each.examDetail.range = `${i18n.t('Common.from')} ${each.examDetail.range_start} ${i18n.t('Common.to')} ${each.examDetail.range_end}`
      each.detail.map((eachRecord) => {
        eachRecord.used_time = secondToHMS(eachRecord.used_time)
        eachRecord.correct_rate = roundDecimal(eachRecord.correct_rate * 100, 2) + '%'
      })
    })
    if (payload.mode === 'EXAMSIMULATION') {
      state.examSimulationHistory = payload.data
    } else if (payload.mode === 'EXAM') {
      state.examHistory = payload.data
    }
  },
  setCertList (state, payload) {
    state.certList = payload
  }
}

const actions = {
  fetchLearnNewOrReviewHistory ({ commit }, payload) {
    commit('setWait', { mode: payload.mode, flag: true })
    axios.get(getVocabularyLearnNewOrReviewHistoryAPI, { params: { mode: payload.mode } })
      .then((res) => {
        commit('setLearnNewOrReviewHistory', {
          mode: payload.mode,
          data: res.data.message
        })
        commit('setWait', { mode: payload.mode, flag: false })
      })
      .catch((err) => {
        console.log('err: ', err)
      })
  },
  fetchExamHistory ({ commit }, payload) {
    commit('setWait', { mode: payload.mode, flag: true })
    axios.get(getVocabularyExamHistoryAPI, { params: { mode: payload.mode } })
      .then((res) => {
        commit('setExamHistory', {
          mode: payload.mode,
          data: res.data.message
        })
        commit('setWait', { mode: payload.mode, flag: false })
      })
      .catch((err) => {
        console.log('err: ', err)
      })
  },
  fetchAllCerts ({ commit }) {
    commit('setWait', { mode: 'CERT', flag: true })
    return new Promise((resolve, reject) => {
      axios.get(getAllCertsAPI)
        .then((response) => {
          commit('setCertList', response.data)
          commit('setWait', { mode: 'CERT', flag: false })
          resolve()
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
